import { render } from "./NavbarBurger.vue?vue&type=template&id=668f734e"
import script from "./NavbarBurger.vue?vue&type=script&lang=js"
export * from "./NavbarBurger.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__